import React from 'react';
import { useTheme } from '../ThemeContext';
import { useLang } from '../i18n/LanguageContext';

const PriceUrgency = ({ size = 'normal' }) => {
  const { isDark } = useTheme();
  const { isFr } = useLang();
  const isSmall = size === 'small';

  const accentColor = isDark ? '#E6EBF2' : '#1B2A4A';
  const textColor = isDark ? 'rgba(255,255,255,0.6)' : 'rgba(27,42,74,0.7)';

  return (
    <div data-testid="price-urgency" className="flex items-center justify-center gap-3">
      <span className="relative inline-flex rounded-full h-2.5 w-2.5" style={{ backgroundColor: '#4ADE80' }} />
      <span
        className={`${isSmall ? 'text-[13px]' : 'text-[14px]'} font-semibold uppercase tracking-wider`}
        style={{ fontFamily: '"Inter", sans-serif', color: textColor }}
      >
        <span className="font-black" style={{ color: accentColor, fontSize: isSmall ? '16px' : '18px' }}>{isFr ? '49€/mois' : '€49/month'}</span>
        {' '}— {isFr ? 'Sans engagement, résiliable à tout moment' : 'No commitment, cancel anytime'}
      </span>
    </div>
  );
};

export default PriceUrgency;
